import { useFormikContext } from "formik"
import { Box, Grid, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { faCircleInfo } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { FormikDatePicker, FormikSwitch } from "../../../../../shared/components/forms/Formik"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"

import { CreateUpdateProductFormValues } from "../productsTypes"

const useStyles = makeStyles()((theme) => ({
    infoWrap: {
        display: "grid",
        gridTemplateColumns: "0.875rem 1fr",
        background: theme.palette.tailwind.sky[50],
        borderRadius: "0.5rem",
        gap: "0.75rem",
        padding: "0.75rem",
        color: theme.palette.tailwind.sky[700],
        width: "100%",
    },
}))

type AvailabilityDetailsFieldProps = Readonly<{}>

export function AvailabilityDetailsField({}: AvailabilityDetailsFieldProps) {
    const { classes } = useStyles()
    const { errors } = useFormikContext<CreateUpdateProductFormValues>()

    return (
        <>
            <LocalizedStrict id="product-create-availability-from-date-picker" attrs={{ label: true }}>
                <FormikDatePicker
                    name="availabilityDetails.dateInterval.from"
                    range="all"
                    label="From date"
                    slotProps={{
                        field: { clearable: true },
                    }}
                />
            </LocalizedStrict>
            <LocalizedStrict id="product-create-availability-to-date-picker" attrs={{ label: true }}>
                <FormikDatePicker
                    name="availabilityDetails.dateInterval.to"
                    range="all"
                    label="To date"
                    slotProps={{
                        field: { clearable: true },
                    }}
                />
            </LocalizedStrict>
            {typeof errors.availabilityDetails === "string" && (
                <Typography variant="body2" color="error">
                    {errors.availabilityDetails}
                </Typography>
            )}
            <Grid item>
                <LocalizedStrict id="product-create-availability-preorder-switch">
                    <FormikSwitch name="availabilityDetails.allowPreOrder">Disallow pre-order:</FormikSwitch>
                </LocalizedStrict>
            </Grid>
            <Box className={classes.infoWrap}>
                <FontAwesomeIcon icon={faCircleInfo} />
                <LocalizedStrict id="product-create-availability-info">
                    <Typography variant="body2">
                        Customers can pre-order products for future dates in the GoPay app unless you disallow it here.
                    </Typography>
                </LocalizedStrict>
            </Box>
        </>
    )
}
